import VueContext from "@iloq/shared-react/vueContext";
import { ReactElement, useContext } from "react";
import { PartnerStatsLinkButtons } from "./partner-stats-link-buttons";

export function PartnerOrders(): ReactElement {
  const context = useContext(VueContext);
  const orders = context.$store.state.orders?.orders;
  const count = orders?.length ?? 0;

  return (
    <PartnerStatsLinkButtons
      titleKey="partnerProgram.hero.orders"
      count={count}
      titleLink="/orders"
      createKey="partnerProgram.hero.newOrder"
      createLink="/shopping_cart"
    />
  );
}
